export const MODE_ALWAYS = "always";
export const MODE_WORKING = "working";
export const MODE_AWAY = "away";
export const MAX_TEXT_REPLY = 10;
export const ATTACHMENT_MAX_SIZE = 10 * 1024 * 1024;
export const ATTACHMENT_MIN_SIZE = 1024;
export const IMAGE_EXTENSIONS = ["jpg", "jpeg", "jfif", "png", "webp", "gif"];
export const DOCUMENT_EXTENSIONS = [
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "txt",
  "zip",
  "pptx"
];

export function fileExtension(value) {
  const clean = String(value == null ? "" : value).split(/[?#]/)[0];
  const name = clean.split(/[\\/]/).pop() || "";
  const index = name.lastIndexOf(".");
  return index >= 0 ? name.slice(index + 1).toLowerCase() : "";
}

export function fileNameFromUrl(value) {
  const clean = String(value == null ? "" : value).split(/[?#]/)[0];
  const name = clean.split(/[\\/]/).pop() || "";
  try {
    return decodeURIComponent(name);
  } catch (error) {
    return name;
  }
}

export function isImageExtension(value) {
  const ext =
    fileExtension(value) ||
    String(value == null ? "" : value).replace(/^\./, "").toLowerCase();
  return IMAGE_EXTENSIONS.indexOf(ext) !== -1;
}

export function isDocumentExtension(value) {
  const ext =
    fileExtension(value) ||
    String(value == null ? "" : value).replace(/^\./, "").toLowerCase();
  return DOCUMENT_EXTENSIONS.indexOf(ext) !== -1;
}

export function normalizeOptionalTimestamp(value) {
  const text = value == null ? "" : String(value).trim();
  if (
    !text ||
    text === "0000-00-00 00:00:00" ||
    text === "0001-01-01T00:00:00Z"
  ) {
    return null;
  }
  return text;
}

export function escapeHtml(value) {
  return String(value == null ? "" : value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export const MODE_OPTIONS = [
  {
    value: MODE_ALWAYS,
    label: "Balas Otomatis 24 Jam",
    shortLabel: "24 Jam",
    description: "Satu pengaturan menangani respons otomatis sepanjang hari.",
    icon: "fa fa-refresh"
  },
  {
    value: "schedule",
    label: "Atur Berdasarkan Jam Kerja",
    shortLabel: "Jam Kerja",
    description: "Respons dipisah untuk saat jam kerja dan di luar jam kerja.",
    icon: "fa fa-clock-o"
  }
];

export const FREQUENCY_OPTIONS = [
  { value: 15, label: "Sekali per 15 menit" },
  { value: 30, label: "Sekali per 30 menit" },
  { value: 45, label: "Sekali per 45 menit" },
  { value: 60, label: "Sekali per 1 jam" },
  { value: 1440, label: "Sekali per 1 hari" },
  { value: 4320, label: "Sekali per 3 hari" },
  { value: 10080, label: "Sekali per 7 hari" },
  { value: 20160, label: "Sekali per 14 hari" },
  { value: 43200, label: "Sekali per 30 hari" }
];

export const CLOSE_FREQUENCY_OPTIONS = [
  { value: 5, label: "5 menit" },
  { value: 10, label: "10 menit" },
  { value: 15, label: "15 menit" },
  { value: 30, label: "30 menit" },
  { value: 45, label: "45 menit" },
  { value: 60, label: "1 jam" },
  { value: 1440, label: "1 hari" }
];

export function modeFields(mode) {
  if (mode === MODE_ALWAYS) return { is_working_or_away: 0, is_working: 0 };
  if (mode === MODE_WORKING) return { is_working_or_away: 1, is_working: 1 };
  return { is_working_or_away: 1, is_working: 0 };
}

export function modeFromConfig(config) {
  const isWorkingOrAway = Number(config && config.is_working_or_away);
  const isWorking = Number(config && config.is_working);
  if (isWorkingOrAway === 0 && isWorking === 0) return MODE_ALWAYS;
  if (isWorkingOrAway === 1 && isWorking === 1) return MODE_WORKING;
  if (isWorkingOrAway === 1 && isWorking === 0) return MODE_AWAY;
  return "";
}

export function modeLabel(mode) {
  if (mode === MODE_ALWAYS) return "Balas Otomatis 24 Jam";
  if (mode === MODE_WORKING) return "Saat Jam Kerja";
  if (mode === MODE_AWAY) return "Di Luar Jam Kerja";
  return "Belum Diatur";
}

export function agentTypeLabel(config) {
  if (!config) return "-";
  return Number(config.ai_status) === 1 ? "Chat AI" : "Chatbot";
}

export function aiModeLabel(config) {
  if (!config || Number(config.ai_status) !== 1) return "-";
  return config.ai_type === "summarize" ? "Knowledge Base" : "Chat Completions";
}

export function createHeader(mode) {
  const fields = modeFields(mode);
  return {
    id: "",
    title: "",
    network_id: 0,
    license_id: "",
    trigger_on: "all",
    trigger_on_some_type: "any",
    message: "",
    frequency_per_person: 1440,
    image_url: "",
    is_enable_away_message: 0,
    is_enable_away_message_status: false,
    message_away: "",
    away_message_start: null,
    away_message_end: null,
    footer_message: "",
    footer_message_status: false,
    create_datetime: 0,
    update_datetime: 0,
    is_publish: 0,
    message_type: "text",
    button_type: "text_reply",
    is_enable_attach_file: false,
    button_type_away_message: "text_reply",
    list_button_text: "Options",
    is_working_or_away: fields.is_working_or_away,
    is_working: fields.is_working,
    ai_status: 0,
    ai_engine: "",
    ai_model: "",
    ai_type: "summarize",
    ai_summary: "",
    ai_close_status: 0,
    ai_close_frequency: 15,
    ai_close_remarks: "",
    ai_buttons: 0,
    ai_prompt_system: "",
    ai_loading: 0,
    is_ai_create_summary: 0,
    ai_migrated: 0
  };
}

export function createForm(mode) {
  return {
    enabled: true,
    header: createHeader(mode),
    detail_button: [],
    detail_button_away: [],
    detail_some: []
  };
}

function boolNum(value) {
  return value === true || value === 1 || value === "1" ? 1 : 0;
}

function intValue(value, fallback) {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? fallback : parsed;
}

export function normalizeForm(data, mode) {
  const source = data && data.header ? data.header : {};
  const fields = modeFields(mode);
  const header = Object.assign(createHeader(mode), source, fields);
  header.ai_status = boolNum(source.ai_status);
  header.ai_close_status = boolNum(source.ai_close_status);
  header.ai_buttons = boolNum(source.ai_buttons);
  header.ai_loading = boolNum(source.ai_loading);
  header.is_ai_create_summary = boolNum(source.is_ai_create_summary);
  header.is_enable_attach_file = source.is_enable_attach_file === true || source.is_enable_attach_file === 1;
  header.footer_message_status = !!source.footer_message_status;
  header.ai_type = source.ai_type === "summarize" ? "summarize" : "freestyle";
  header.frequency_per_person = intValue(source.frequency_per_person, 1440);
  header.ai_close_frequency = intValue(source.ai_close_frequency, 15);
  header.is_publish = intValue(source.is_publish, 0);
  header.create_datetime = intValue(source.create_datetime, 0);
  header.update_datetime = intValue(source.update_datetime, 0);
  header.away_message_start = normalizeOptionalTimestamp(source.away_message_start);
  header.away_message_end = normalizeOptionalTimestamp(source.away_message_end);
  if (header.ai_status === 0) {
    header.ai_close_status = 0;
    header.ai_buttons = 0;
    header.ai_loading = 0;
    header.is_ai_create_summary = 0;
  }
  if (header.ai_status === 1) {
    header.is_enable_attach_file = false;
    header.image_url = "";
    header.message_type = "text";
  } else if (header.is_enable_attach_file) {
    if (header.message_type !== "image" && header.message_type !== "document") {
      header.message_type = "image";
    }
  } else {
    header.image_url = "";
    header.message_type = "text";
  }
  if (!header.button_type) header.button_type = "text_reply";
  if (!header.button_type_away_message) header.button_type_away_message = "text_reply";
  const detailButton = Array.isArray(data && data.detail_button) ? data.detail_button : [];
  const normalizedDetailButton =
    header.button_type === "text_reply"
      ? detailButton.map(row =>
          Object.assign({}, row, {
            auto_reply_button_id:
              row && row.auto_reply_button_id != null
                ? String(row.auto_reply_button_id)
                : "",
            button_type: "text_reply"
          })
        )
      : detailButton;
  return {
    enabled: true,
    header: header,
    detail_button: normalizedDetailButton,
    detail_button_away: Array.isArray(data && data.detail_button_away) ? data.detail_button_away : [],
    detail_some: Array.isArray(data && data.detail_some) ? data.detail_some : []
  };
}

export function buildConfigPayload(form, licenseId) {
  const header = Object.assign({}, form.header);
  header.network_id = intValue(header.network_id, 0);
  header.license_id = licenseId;
  header.trigger_on = "all";
  header.trigger_on_some_type = "any";
  header.is_publish = 0;
  header.frequency_per_person = intValue(header.frequency_per_person, 1440);
  header.ai_close_frequency = intValue(header.ai_close_frequency, 15);
  header.ai_status = boolNum(header.ai_status);
  header.ai_close_status = boolNum(header.ai_close_status);
  header.ai_buttons = boolNum(header.ai_buttons);
  header.ai_loading = boolNum(header.ai_loading);
  header.is_ai_create_summary = boolNum(header.is_ai_create_summary);
  header.is_enable_attach_file = header.is_enable_attach_file === true;
  header.is_enable_away_message = 0;
  header.is_enable_away_message_status = false;
  header.away_message_start = null;
  header.away_message_end = null;
  header.create_datetime = intValue(header.create_datetime, 0);
  header.update_datetime = intValue(header.update_datetime, 0);
  if (header.ai_type !== "summarize" && header.ai_type !== "freestyle") {
    header.ai_type = "summarize";
  }
  if (header.ai_status === 1 && header.ai_type === "freestyle") {
    header.ai_summary = "";
  }
  if (header.ai_status === 1) {
    header.is_enable_attach_file = false;
    header.image_url = "";
    header.message_type = "text";
  } else if (header.is_enable_attach_file) {
    header.message_type = header.message_type === "document" ? "document" : "image";
  } else {
    header.image_url = "";
    header.message_type = "text";
  }
  if (header.ai_status === 0 && !header.button_type) {
    header.button_type = "text_reply";
  }

  let detailButton = form.detail_button || [];
  if (header.ai_status === 1) {
    // Text Reply tidak relevan untuk Chat AI. Kosongkan payload agar backend
    // tidak menghapus detail Text Reply lama; backend juga mempertahankannya.
    detailButton = [];
  } else if (header.button_type === "text_reply") {
    const seen = {};
    detailButton = (form.detail_button || [])
      .filter(row => row && row.auto_reply_button_id)
      .filter(row => {
        const id = String(row.auto_reply_button_id);
        if (seen[id]) return false;
        seen[id] = true;
        return true;
      })
      .slice(0, MAX_TEXT_REPLY)
      .map((row, index) => ({
        auto_reply_button_id: String(row.auto_reply_button_id),
        button_type: "text_reply",
        button_order_by: index
      }));
  }

  // Footer tidak diedit di V2. Nilai lama dipertahankan apa adanya agar
  // konfigurasi lama tidak berubah tanpa persetujuan pengguna.
  return {
    header: header,
    detail_button: detailButton,
    detail_button_away: form.detail_button_away || [],
    detail_some: form.detail_some || []
  };
}

export function validateFormDetailed(form) {
  const errors = [];
  const header = (form && form.header) || {};
  const add = (field, message, step) => {
    errors.push({ field: field, message: message, step: step || 4 });
  };
  const aiStatus = Number(header.ai_status);

  if (!header.title || !header.title.trim()) {
    add("title", "Judul pengaturan wajib diisi.");
  }
  if (header.title && header.title.length > 50) {
    add("title", "Judul pengaturan maksimal 50 karakter.");
  }
  if (!header.message || !header.message.trim()) {
    add("message", "Pesan respons wajib diisi.");
  }
  if (header.message && header.message.length > 1024) {
    add("message", "Pesan respons maksimal 1024 karakter.");
  }
  if (aiStatus !== 0 && aiStatus !== 1) {
    add("agentType", "Silakan pilih jenis agent.", 3);
  }
  if (!header.frequency_per_person || Number(header.frequency_per_person) <= 0) {
    add("frequency", "Frekuensi per orang wajib dipilih.");
  }
  if (aiStatus === 1 && header.is_enable_attach_file) {
    add("attachment", "Lampiran tidak dapat digunakan saat Chat AI aktif.");
  } else if (header.is_enable_attach_file) {
    if (header.message_type !== "image" && header.message_type !== "document") {
      add("attachment", "Pilih jenis lampiran Image atau Document.");
    }
    if (!header.image_url) {
      add("attachment", "Pilih file lampiran atau matikan Lampiran.");
    } else {
      const ext = fileExtension(header.image_url);
      if (header.message_type === "image" && ext && !isImageExtension(ext)) {
        add("attachment", "File lampiran bukan gambar yang didukung.");
      }
      if (header.message_type === "document" && ext && !isDocumentExtension(ext)) {
        add("attachment", "File lampiran bukan dokumen yang didukung.");
      }
    }
  }
  if (aiStatus === 0 && header.button_type === "text_reply") {
    const textReplies = (form.detail_button || []).filter(
      row => row && row.auto_reply_button_id
    );
    if (textReplies.length > MAX_TEXT_REPLY) {
      add("textReply", "Text Reply maksimal " + MAX_TEXT_REPLY + " pilihan.");
    }
    const ids = textReplies.map(row => String(row.auto_reply_button_id));
    if (ids.length !== new Set(ids).size) {
      add("textReply", "Pilihan Text Reply tidak boleh sama.");
    }
  }
  if (aiStatus === 1 && ["freestyle", "summarize"].indexOf(header.ai_type) === -1) {
    add("aiMode", "Mode AI belum valid. Pilih Chat Completions atau Knowledge Base.");
  }
  if (
    aiStatus === 1 &&
    Number(header.ai_close_status) === 1 &&
    (!header.ai_close_frequency || Number(header.ai_close_frequency) <= 0)
  ) {
    add("session", "Frekuensi tutup sesi wajib dipilih.");
  }
  return errors;
}

export function validateForm(form) {
  return validateFormDetailed(form).map(item => item.message);
}

export function isActive(config) {
  return Number(config && config.is_publish) === 1;
}

export function configSort(a, b) {
  return intValue(a.create_datetime, 0) - intValue(b.create_datetime, 0);
}

export function licenseConfigs(configs, licenseId) {
  return (configs || []).filter(item => item.license_id === licenseId).sort(configSort);
}

export function buildConflictDetails(configs) {
  const list = configs || [];
  const groups = {
    always: list.filter(item => modeFromConfig(item) === MODE_ALWAYS),
    working: list.filter(item => modeFromConfig(item) === MODE_WORKING),
    away: list.filter(item => modeFromConfig(item) === MODE_AWAY)
  };
  const details = [];

  [
    { key: MODE_ALWAYS, configs: groups.always },
    { key: MODE_WORKING, configs: groups.working },
    { key: MODE_AWAY, configs: groups.away }
  ].forEach(group => {
    if (group.configs.length > 1) {
      details.push({
        key: "duplicate-" + group.key,
        title: "Pengaturan respons bertabrakan",
        mode: group.key,
        modeLabel: modeLabel(group.key),
        configs: group.configs,
        count: group.configs.length,
        reason:
          "Ditemukan " + group.configs.length + " pengaturan " + modeLabel(group.key) +
          " pada lisensi ini. Hanya satu pengaturan untuk mode ini yang boleh digunakan."
      });
    }
  });

  const activeAlways = groups.always.filter(isActive);
  const activeSchedule = groups.working.concat(groups.away).filter(isActive);
  if (activeAlways.length > 0 && activeSchedule.length > 0) {
    details.push({
      key: "always-schedule",
      title: "Pengaturan 24 Jam dan jam kerja bertabrakan",
      mode: "mixed",
      modeLabel: "Balas Otomatis 24 Jam + Jam Kerja",
      configs: activeAlways.concat(activeSchedule),
      count: activeAlways.length + activeSchedule.length,
      reason:
        "Balas Otomatis 24 Jam tidak dapat aktif bersamaan dengan pengaturan Saat Jam Kerja atau Di Luar Jam Kerja. Nonaktifkan salah satu pengaturan yang tidak diperlukan."
    });
  }

  return details;
}

export function analyzeConfigs(configs) {
  const list = configs || [];
  const totalCounts = {};
  const activeCounts = {};
  const active = [];
  list.forEach(item => {
    const mode = modeFromConfig(item);
    if (!mode) return;
    totalCounts[mode] = (totalCounts[mode] || 0) + 1;
    if (isActive(item)) {
      activeCounts[mode] = (activeCounts[mode] || 0) + 1;
      active.push(item);
    }
  });

  const details = buildConflictDetails(list);
  const messages = details.map(item => item.reason);

  return {
    totalCounts: totalCounts,
    activeCounts: activeCounts,
    active: active,
    details: details,
    hasConflict: details.length > 0,
    messages: messages
  };
}

export function isConflictError(error) {
  const message = String((error && (error.message || error.msg)) || "");
  return /konflik|bertabrakan|sudah ada|sudah pernah/i.test(message);
}

export function mapApiError(error, fallback) {
  const raw = String((error && (error.message || error.msg)) || "").toLowerCase();
  if (raw.indexOf("sesi login") !== -1 || raw.indexOf("unauthorized") !== -1) {
    return { message: "Sesi Anda sudah berakhir. Silakan masuk kembali.", field: "", step: 1 };
  }
  if (
    raw.indexOf("jam kerja belum") !== -1 ||
    raw.indexOf("jam operasional") !== -1 ||
    raw.indexOf("hari operasional") !== -1 ||
    raw.indexOf("status jam kerja") !== -1 ||
    raw.indexOf("format jam kerja") !== -1 ||
    raw.indexOf("jam buka dan jam tutup") !== -1 ||
    raw.indexOf("jam tutup") !== -1
  ) {
    return {
      message:
        "Jam kerja belum diatur atau belum valid. Atur hari dan jam operasional sebelum mengaktifkan agent berbasis jam kerja.",
      field: "",
      step: 2,
      workingHours: true
    };
  }
  if (raw.indexOf("konflik") !== -1 || raw.indexOf("bertabrakan") !== -1) {
    let message =
      "Lisensi ini sudah memiliki pengaturan yang bertabrakan. Buka detail konflik untuk memperbaikinya.";
    if (raw.indexOf("24 jam") !== -1) {
      message =
        "Lisensi ini sudah memiliki pengaturan Balas Otomatis 24 Jam lain. Buka detail konflik untuk memperbaikinya.";
    } else if (raw.indexOf("jam kerja") !== -1 || raw.indexOf("schedule") !== -1) {
      message =
        "Lisensi ini sudah memiliki pengaturan jam kerja yang bertabrakan. Buka detail konflik untuk memperbaikinya.";
    }
    return { message: message, field: "", step: 5, conflict: true };
  }
  if (raw.indexOf("sudah ada") !== -1 || raw.indexOf("sudah pernah") !== -1) {
    return {
      message:
        "Pengaturan untuk mode ini sudah ada. Buka detail konflik untuk menonaktifkan atau menghapus pengaturan lain.",
      field: "",
      step: 5,
      conflict: true
    };
  }
  if (raw.indexOf("lisensi tidak ditemukan") !== -1 || raw.indexOf("bukan milik") !== -1) {
    return { message: "Lisensi tidak ditemukan atau bukan milik Anda.", field: "", step: 1 };
  }
  if (raw.indexOf("pilih lisensi") !== -1 || raw.indexOf("lisensi wajib") !== -1) {
    return { message: "Pilih lisensi WhatsApp terlebih dahulu.", field: "", step: 1 };
  }
  if (raw.indexOf("text reply") !== -1) {
    return {
      message:
        "Text Reply yang dipilih tidak ditemukan. Pilih ulang atau buat Text Reply baru.",
      field: "textReply",
      step: 4
    };
  }
  if (raw.indexOf("respond message") !== -1 || raw.indexOf("message is required") !== -1) {
    return { message: "Pesan respons wajib diisi.", field: "message", step: 4 };
  }
  if (raw.indexOf("title is required") !== -1 || raw.indexOf("judul") !== -1) {
    return {
      message: "Judul pengaturan wajib diisi, maksimal 50 karakter.",
      field: "title",
      step: 4
    };
  }
  if (
    raw.indexOf("parsing time") !== -1 ||
    raw.indexOf("cannot parse") !== -1 ||
    raw.indexOf("away_message_start") !== -1 ||
    raw.indexOf("away_message_end") !== -1
  ) {
    return {
      message:
        "Format waktu pada konfigurasi tidak valid. Periksa kembali pengaturan jadwal.",
      field: "",
      step: 4
    };
  }
  if (raw.indexOf("frequency per person") !== -1) {
    return {
      message: "Frekuensi per orang wajib dipilih.",
      field: "frequency",
      step: 4
    };
  }
  if (raw.indexOf("ukuran file") !== -1 || raw.indexOf("maksimal 10") !== -1) {
    return {
      message: "Ukuran file lampiran maksimal 10 MB.",
      field: "attachment",
      step: 4
    };
  }
  if (
    raw.indexOf("hanya mengizinkan file") !== -1 ||
    raw.indexOf("format file") !== -1 ||
    raw.indexOf("mime") !== -1 ||
    raw.indexOf("bukan gambar") !== -1 ||
    raw.indexOf("bukan dokumen") !== -1
  ) {
    return {
      message:
        "Format file lampiran tidak sesuai dengan jenis media yang dipilih.",
      field: "attachment",
      step: 4
    };
  }
  if (
    raw.indexOf("jenis lampiran") !== -1 ||
    raw.indexOf("lampiran tidak dapat") !== -1 ||
    raw.indexOf("file lampiran wajib") !== -1 ||
    raw.indexOf("referensi lampiran") !== -1
  ) {
    return {
      message:
        raw.indexOf("chat ai") !== -1
          ? "Lampiran tidak dapat digunakan saat Chat AI aktif."
          : raw.indexOf("referensi lampiran") !== -1
            ? "Referensi lampiran bukan milik lisensi ini. Pilih ulang file lampiran."
            : "Lampiran belum lengkap. Pilih jenis media dan file lampiran.",
      field: "attachment",
      step: 4
    };
  }
  if (
    raw.indexOf("file or image") !== -1 ||
    raw.indexOf("lampiran") !== -1 ||
    raw.indexOf("upload") !== -1
  ) {
    return {
      message: "Lampiran belum tersedia atau belum selesai diunggah.",
      field: "attachment",
      step: 4
    };
  }
  if (raw.indexOf("mode ai") !== -1 || raw.indexOf("ai_type") !== -1) {
    return {
      message: "Mode AI belum valid. Pilih Chat Completions atau Knowledge Base.",
      field: "aiMode",
      step: 4
    };
  }
  if (raw.indexOf("5 dari 5") !== -1 || raw.indexOf("maksimal 5") !== -1) {
    return {
      message: "Lisensi ini sudah menggunakan 5 dari 5 Knowledge Base.",
      field: "knowledgeBase",
      step: 4
    };
  }
  if (raw.indexOf("knowledge base") !== -1) {
    return {
      message: "Knowledge Base belum siap. Periksa dokumen Knowledge Base lisensi ini.",
      field: "knowledgeBase",
      step: 4
    };
  }
  if (raw.indexOf("kamu belum bisa menggunakan fitur ai") !== -1 || raw.indexOf("api key") !== -1) {
    return {
      message:
        "Chat AI belum dapat digunakan pada akun ini. Hubungi admin atau aktifkan fitur AI terlebih dahulu.",
      field: "aiMode",
      step: 3
    };
  }
  if (raw.indexOf("mode 24 jam") !== -1) {
    return {
      message: "Mode 24 Jam hanya boleh memiliki satu pengaturan.",
      field: "agentType",
      step: 3
    };
  }
  if (raw.indexOf("mode respons") !== -1 || raw.indexOf("mode konfigurasi") !== -1) {
    return {
      message: "Mode respons belum sesuai. Pilih mode 24 Jam atau Jam Kerja.",
      field: "agentType",
      step: 3
    };
  }
  if (raw.indexOf("konfigurasi harus berisi") !== -1 || raw.indexOf("1 atau 2 mode") !== -1) {
    return {
      message: "Pilih mode respons yang akan disertakan.",
      field: "agentType",
      step: 3
    };
  }
  if (raw.indexOf("data is not found") !== -1 || raw.indexOf("not found") !== -1 || raw.indexOf("tidak ditemukan") !== -1) {
    return {
      message: "Pengaturan ini tidak ditemukan atau sudah dihapus.",
      field: "",
      step: 5
    };
  }
  if (raw.indexOf("lisensi dan") !== -1) {
    return { message: "Pilih lisensi dan pengaturan yang ingin diproses.", field: "", step: 1 };
  }
  return {
    message: fallback || "Pengaturan belum berhasil disimpan. Periksa kembali isian Anda atau coba lagi.",
    field: "",
    step: 5
  };
}

export function friendlyError(error, fallback) {
  return mapApiError(error, fallback).message;
}

export function activationIds(configs, mode) {
  const list = configs || [];
  if (mode === MODE_ALWAYS) {
    const row = list.filter(item => modeFromConfig(item) === MODE_ALWAYS)[0];
    return row ? [row.id] : [];
  }
  return list
    .filter(item => {
      const itemMode = modeFromConfig(item);
      return itemMode === MODE_WORKING || itemMode === MODE_AWAY;
    })
    .map(item => item.id);
}

export function licenseMode(configs) {
  const analysis = analyzeConfigs(configs);
  if (analysis.activeCounts[MODE_ALWAYS] > 0) return MODE_ALWAYS;
  if (analysis.activeCounts[MODE_WORKING] > 0 || analysis.activeCounts[MODE_AWAY] > 0) {
    return "schedule";
  }
  if ((analysis.totalCounts[MODE_ALWAYS] || 0) > 0) return MODE_ALWAYS;
  if ((analysis.totalCounts[MODE_WORKING] || 0) > 0 || (analysis.totalCounts[MODE_AWAY] || 0) > 0) {
    return "schedule";
  }
  return "";
}

export function aggregateAgentType(configs) {
  const all = configs || [];
  const active = all.filter(isActive);
  const list = active.length ? active : all;
  if (!list.length) return "-";
  const types = {};
  list.forEach(item => {
    types[Number(item.ai_status) === 1 ? "ai" : "chatbot"] = true;
  });
  if (types.ai && types.chatbot) return "Chatbot + Chat AI";
  return types.ai ? "Chat AI" : "Chatbot";
}

export function aggregateAiMode(configs) {
  const all = configs || [];
  const active = all.filter(item => isActive(item) && Number(item.ai_status) === 1);
  const list = active.length ? active : all.filter(item => Number(item.ai_status) === 1);
  if (!list.length) return "-";
  const modes = {};
  list.forEach(item => {
    modes[item.ai_type === "summarize" ? "kb" : "completion"] = true;
  });
  if (modes.kb && modes.completion) return "Campuran";
  return modes.kb ? "Knowledge Base" : "Chat Completions";
}

export function licenseStatus(configs, analysis) {
  const list = configs || [];
  if (analysis && analysis.hasConflict) return "conflict";
  if (list.some(isActive)) return "active";
  if (list.length > 0) return "draft";
  return "unconfigured";
}



// WEBPACK FOOTER //
// ./src/views/ai/agentV2/utils.js